<template>
  <section class="content">
    <div class="menu">
      <span class="item active">
        热门
      </span>
      <span class="item" @click="openApp">
        最新
      </span>
      <span 
        class="item" 
        v-for="option in voteOptions"
        :key="option.option.optionId"
        @click="openApp"
      >
        {{option.option.optionText}}({{option.feedCount}})
      </span>
    </div>
    <div class="feed" v-if="topicFeedWrappers && Object.keys(topicFeedWrappers).length">
      <div
        class="feed-list" 
        v-for="feed in topicFeedWrappers" 
        :key="feed.topicFeed.feedId">
        <div class="main">
          <a :href="`/share/feed/${feed.topicFeed.feedId}`">
            <div class="title">
              <img class="avatar" :src="feed.userWrapper.user.imageUrl || 'https://easyreadfs.nosdn.127.net/66e4dfba70ea49278fc3c639026e88ee'" alt="avatar">
              <span class="nickName">{{feed.userWrapper.user.nickName}}</span>
                <span class="ctime">{{formatTime(feed.topicFeed.createTime)}}</span>
              <img class="highlight" v-if="feed.topicFeed.highlight" src="../../assets/tag_elite@3x.png" />
            </div>
            <FeedTextItem :items="feed.items" :voteOption="feed.voteOption" />
            <FeedImgItem :items="feed.items.filter(item => item.resourceType === 'Image')" />
          </a>
          <div class="footer" @click="openApp">
            <span class="mes">
              <img class="mes-icon" src="../../assets/common_comment_ic_normal@3x.png" alt="" />
              <span class="text" v-if="feed.topicFeed.commentCount">{{formatCount(feed.topicFeed.commentCount)}}</span>
            </span>
            <img class="icon share" src="../../assets/share_ic_normal@3x.png" />
            <img class="icon more" src="../../assets/greytheme_more_ic_normal@3x.png" />
            <span class="like">
              <span class="text">{{formatCount(feed.topicFeed.likeCount)}}</span>
              <img class="like-icon" src="../../assets/like_greytheme_normal@3x.png" alt="">
            </span>
          </div>
        </div>
        <div class="gutter" />
      </div>
    </div>
    <div class="empty-feed" v-else>
      暂无内容
    </div>
  </section>
</template>
<script>
import FeedTextItem from './FeedTextItem'
import FeedImgItem from './FeedImgItem'
import { formatTime, formatCount } from '../../utils/formatNum'

export default {
  name: 'Content',
  components: {
    FeedTextItem,
    FeedImgItem
  },
  props: {
    voteOptions: {
      type: Array,
      default: () => []
    },
    topicFeedWrappers: {
      type: Array,
      default: () => []
    },
    openApp: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      formatTime: formatTime,
      formatCount: formatCount
    }
  }
}
</script>
<style lang="scss" scoped>
.content {
  margin-top: .48rem;
  .menu {
    box-sizing: border-box;
    padding: 0 .42rem;
    border-bottom: 1px solid #ececec;
    height: .88rem;
    white-space: nowrap;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .item {
    display: inline-block;
    line-height: .82rem;
    height: .82rem;
    font-family: HYQiHei-EZS;
    font-size: .32rem;
    color: rgba(68,68,68,0.50);
    letter-spacing: 0;
    text-align: center;
    margin-right: .64rem;
    &:last-child {
      margin: 0;
    }
  }
  .active {
    color: #444444;
    font-weight: 500;
    border-bottom: 2px solid #545454;
  }
  .feed {
    .feed-list {
      .main {
        padding: .48rem .32rem .4rem .32rem;
        .title {
          .avatar {
            width: .64rem;
            border-radius: 50%;
            margin-right: .24rem;
            vertical-align: middle;
          }
          .nickName {
            font-family: HYQiHei-FZS;
            font-size: .28rem;
            font-weight: 500;
            color: #444444;
            line-height: .28rem;
            vertical-align: middle;
          }
          .highlight {
            width: .86rem;
            height: .86rem;
            float: right;
            margin-right: .48rem;
            margin-top: -.1rem;
          }
          .ctime {
            float: right;
            font-family: PingFangSC-Regular;
            font-size: .28rem;
            color: #B3B3B3;
            text-align: right;
            line-height: .28rem;
            padding-top: .15rem;
          }
        }
        .footer {
          margin-top: .26rem;
          img {
              width: .32rem;
              height: .32rem;
            }
          .mes {
            position: relative;
            margin-right: .56rem;
            display: inline-block;
            .text {
              height: .28rem;
              line-height: .28rem;
              background-color: #ce5959;
              border-radius: .14rem;
              padding: 0 .08rem;
              font-family: Avenir-Roman;
              font-size: .2rem;
              color: #FFFFFF;
              text-align: center;
              position: absolute;
              top: -.15rem;
              left: .2rem;
            }
          }
          .share {
            margin-right: .56rem;
          }
          .like {
            float: right;
            padding-top: .1rem;
            .like-icon {
              vertical-align: middle;
            }
            .text {
              vertical-align: middle;
              font-family: HYQiHei-EZS;
              font-size: .28rem;
              color: #B3B3B3;
              text-align: right;
              line-height: .28rem;
              margin-right: .11rem;
            }
          }
        }
      }
      .gutter {
        height: .16rem;
        background: #F6F6F6;
      }
    }
  }
  .empty-feed {
    min-height: 5rem;
    text-align: center;
    font-family: HYQiHei-EZS;
    font-size: .3rem;
    color: #B3B3B3;
    letter-spacing: 0;
    line-height: 5rem;
  }
}
</style>
